// GENERATED FILE - DO NOT MODIFY

export enum CompanyNumberOfEmployeesDto {
    OnePlus = "OnePlus",
    TwentySixPlus = "TwentySixPlus",
    FiftyOnePlus = "FiftyOnePlus",
    SeventySixPlus = "SeventySixPlus",
    OneHundredOnePlus = "OneHundredOnePlus",
}